import { memo } from "react";
import { Card, Typography } from "antd";
import { TitleSlide } from "./TitleSlide";
import { FigureSlide } from "./FigureSlide";
import { QuoteSlide } from "./QuoteSlide";
import { BulletPointSlide } from "./BulletPointSlide";
import { ImageSlide } from "./ImageSlide";
import { DoubleParagraphSlide } from "./DoubleParagraphSlide";
import { ParagraphImageSlide } from "./ParagraphImageSlide";
import { Slide } from "pages/media/types/";

export interface SlideComponentProps {
  slide: Slide;
  isActive?: boolean;
  onComplete?: () => void;
}

const SLIDE_COMPONENTS: Record<string, React.FC<SlideComponentProps>> = {
  title: TitleSlide,
  figure: FigureSlide,
  quote: QuoteSlide,
  bullet_point: BulletPointSlide,
  image: ImageSlide,
  double_paragraph: DoubleParagraphSlide,
  paragraph_image: ParagraphImageSlide,
};

interface SlideRendererProps {
  slide: Slide;
  isActive?: boolean;
  onComplete?: () => void;
}

export const SlideRenderer = memo(
  ({ slide, isActive = false, onComplete }: SlideRendererProps) => {
    const Component = SLIDE_COMPONENTS[slide.slide_type];

    if (!Component) {
      return (
        <Card>
          <Typography.Text type="warning">
            Unknown slide type: {slide.slide_type}
          </Typography.Text>
          <pre>{JSON.stringify(slide.placeholders, null, 2)}</pre>
        </Card>
      );
    }

    return (
      <Component slide={slide} isActive={isActive} onComplete={onComplete} />
    );
  }
);

SlideRenderer.displayName = "SlideRenderer";
